import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core'
import { NgForm } from '@angular/forms'
import { moment } from 'ngx-bootstrap/chronos/test/chain'
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal'

import { Estabelecimento } from '../../pkw-data/collect/estabelecimento/estabelecimento.model'
import { OperadoraDeMaquina } from '../../pkw-data/collect/operadora-de-maquina.model'
import { Empresa } from '../../pkw-data/core/empresa.model'
import { EstabelecimentoService } from '../shared/estabelecimento.service'
import { DadosOperadoras } from './dados-operadoras'
import { Situacao } from '../../pkw-data/collect/estabelecimento/situacao.enum'
import { EstabelecimentoModalConfirmacaoComponent } from '../estabelecimento-modal-confirmacao/estabelecimento-modal-confirmacao.component'
import { EstabelecimentoValidarService } from '../shared/estabelecimento-validar.service'
import { AlertService } from '../../common/alert/shared/alert.service'

@Component({
    selector: 'col-estabelecimento-modal',
    templateUrl: './estabelecimento-modal.component.html',
    styles: ['.modal-body { padding-bottom: 0;}'],
})
export class EstabelecimentoModalComponent implements OnInit {
    @Input() estabelecimento: Estabelecimento = null
    @Input() operadoras: OperadoraDeMaquina[]
    @Input() empresas: Empresa[]
    @Input() limiteParaMeses: OperadoraDeMaquina
    @Input() isEdicao: boolean = false

    @Input()
    @Output()
    salvo = new EventEmitter<Estabelecimento>()

    @ViewChild(NgForm) form: NgForm

    operadora: OperadoraDeMaquina
    alterarSenha: boolean
    senhaObrigatoria: boolean
    operadoraMicrocopia: string
    numeroLabel: string
    numeroPlaceholder: string
    numeroMaxlength: number
    numeroMicrocopia: string
    utilizaNumero: boolean
    utilizaCodigo: boolean
    utilizaToken: boolean
    usuarioLabel: string
    usuarioPlaceholder: string
    usuarioDeveSerEmail: boolean
    usuarioPattern: string
    usuarioMaxlength: number
    usuarioNumerico: boolean
    senhaPattern: string
    senhaMaxlength: number
    senhaNumerica: boolean
    enviandoDados: boolean
    limite: any
    limiteMeses: number
    limiteParaSincronizaremMeses: number
    nome: string
    dataMaximaPeriodoInicial: Date
    operadoraToken: string
    codigoAcessoMaxlength: number
    operadoraConfirmaEmail: string
    estabelecimentoEmail: boolean

    errorMessages = ERROR_MESSAGES

    constructor(
        private modalService: BsModalService,
        private bsModalRef: BsModalRef,
        private estabelecimentoService: EstabelecimentoService,
        private estabelecimentoValidarService: EstabelecimentoValidarService,
        private alertService: AlertService
    ) {}

    ngOnInit() {
        this.enviandoDados = false
        this.alterarSenha = !this.isEdicao

        let operadora = this.estabelecimento
            ? this.estabelecimento.agente.operadoraDeMaquina
            : null
        this.verificarOperadora(operadora)

        if (this.isEdicao) {
            this.initEdicao()
        } else {
            this.initNovo()
        }

        this.operadoras = this.operadoras.filter((e) => e.ativo)
    }

    clickSalvar() {
        if (this.form.valid) {
            this.atualizarDados(this.estabelecimento)

            let nomeOperadora = this.estabelecimento.agente.operadoraDeMaquina.nome
            let numeroEstabelecimento = this.estabelecimento.numero
            if (nomeOperadora == 'Stone') {
                this.validarEstabelecimentoStone(nomeOperadora, numeroEstabelecimento)
                return
            }

            this.salvarEstabelecimento()
        }
    }

    salvarEstabelecimento() {
        if (this.isNecessarioConfirmar() && !this.isEdicao) {
            this.modalConfirmacaoOuCancelamento()
            return
        }

        this.enviandoDados = true
        this.estabelecimentoService.salvar(this.estabelecimento).subscribe(() => {
            this.salvo.emit(this.estabelecimento)
            this.fechar()
        })
    }

    validarEstabelecimentoStone(nomeOperadora, numero) {
        this.enviandoDados = true
        this.estabelecimentoValidarService
            .validar(nomeOperadora, numero)
            .toPromise()
            .then(() => this.salvarEstabelecimento())
            .catch(() => {
                let mensagem =
                    'O número de estabelecimento fornecido é inválido. Favor verificar para continuar ' +
                    (this.isEdicao ? 'a edição' : 'o cadastro') +
                    '.'
                this.alertService.danger(mensagem, 'Aviso')
                this.enviandoDados = false
            })
    }

    modalConfirmacaoOuCancelamento() {
        this.fechar()

        const modal = this.modalService.show(EstabelecimentoModalConfirmacaoComponent, {
            initialState: {
                titulo: 'AVISO',
                modalContent: this.getModalConfirmacaoContent(),
            },
            backdrop: 'static',
            keyboard: false,
        })

        modal.content.onClose.subscribe((confirmado) => {
            if (confirmado) {
                modal.content.carregando = true

                this.estabelecimentoService.salvar(this.estabelecimento).subscribe(() => {
                    this.salvo.emit(this.estabelecimento)
                    modal.hide()
                })

                return
            }

            const initialState = {
                operadoras: this.operadoras,
                empresas: this.empresas,
                estabelecimento: this.estabelecimento,
                salvo: this.salvo,
            }

            this.bsModalRef = this.modalService.show(EstabelecimentoModalComponent, {
                initialState,
                backdrop: 'static',
                keyboard: false,
            })
        })
    }

    verificarOperadora(operadora: OperadoraDeMaquina) {
        this.operadoraMicrocopia = this.obterMicrocopiaOperadora(operadora)
        this.utilizaNumero = DadosOperadoras.utilizaNumeroEstabelecimento(operadora)
        this.utilizaCodigo = DadosOperadoras.utilizaCodigoAcesso(operadora)
        this.utilizaToken = DadosOperadoras.utilizaToken(operadora)
        this.atualizarInputUsuario(operadora)
        this.atualizarInputNumero(operadora)
        this.atualizarInputSenha(operadora)
        this.atualizarInputCodigoAcesso(operadora)

        let nomeOperadora = operadora ? operadora.nome : ''
        this.senhaObrigatoria = this.isSenhaObrigatoriaByOperadora(nomeOperadora)
    }

    fechar() {
        this.bsModalRef.hide()
    }

    toggleAlterarSenha() {
        this.alterarSenha = !this.alterarSenha
    }

    tokenContainerSize() {
        if (this.utilizaToken && this.isEdicao) {
            return 'col-sm-6'
        }
        return 'col-sm-6'
    }

    periodoContainerSize() {
        if (this.limiteMeses) {
            return 'col-sm-6'
        }
        return 'col-sm-6'
    }

    codigoContainerSize() {
        if (this.utilizaCodigo && this.isEdicao) {
            return 'col-sm-6'
        }
        if (this.utilizaToken && this.isEdicao) {
            return 'col-sm-6'
        }
        return 'col-sm-4'
    }

    numeroContainerSize() {
        if (this.utilizaCodigo && this.isEdicao) {
            return 'col-sm-6'
        }
        if (this.utilizaCodigo) {
            return 'col-sm-4'
        }
        if (this.utilizaToken && this.isEdicao) {
            return 'col-sm-6'
        }
        if (this.utilizaToken) {
            return 'col-sm-4'
        }
        return this.isEdicao ? 'col-sm-4' : 'col-sm-6'
    }

    usuarioContainerSize() {
        if (this.utilizaCodigo && this.isEdicao) {
            return 'col-sm-6'
        }
        if (this.utilizaCodigo) {
            return 'col-sm-4'
        }
        if (this.utilizaToken && this.isEdicao) {
            return 'col-sm-6'
        }
        if (this.utilizaToken) {
            return 'col-sm-6'
        }
        if (this.isEdicao) {
            return this.utilizaNumero ? 'col-sm-4' : 'col-sm-8'
        }
        return this.utilizaNumero ? 'col-sm-6' : 'col-sm-12'
    }

    botaoSize() {
        if (this.utilizaCodigo && this.isEdicao) {
            return 'form-group col-sm-6'
        }
        if (this.utilizaToken && this.isEdicao) {
            return 'form-group col-sm-6'
        }
        return 'form-group col-sm-4'
    }

    private initNovo() {
        if (!this.estabelecimento)
            this.estabelecimento = this.estabelecimentoService.novo()

        setTimeout(() => this.preencherForm(this.estabelecimento, true))
    }

    private initEdicao() {
        if (this.estabelecimento.possuiMovimentos) {
            this.numeroMicrocopia = 'Campo desabilitado pois já existem vendas baixadas'
        }

        setTimeout(() => this.preencherForm(this.estabelecimento, false))
    }

    private preencherForm(estabelecimento: Estabelecimento, manterSenha: Boolean) {
        let senha = manterSenha ? estabelecimento.agente.senha : ''

        this.form.reset({
            empresa: estabelecimento.empresa && estabelecimento.empresa.empresa,
            codigoAcesso: estabelecimento.codigoAcesso,
            operadora: estabelecimento.agente.operadoraDeMaquina,
            numero: this.formatarNumeroEstabelecimento(estabelecimento.numero),
            usuario: estabelecimento.agente.usuario,
            token: estabelecimento.token,
            dataInicial: estabelecimento.dataInicial,
            utilizaApi: estabelecimento.utilizaApi,
            senha: senha,
            confirmacaoSenha: senha,
        })
    }

    private atualizarDados(estabelecimento: Estabelecimento) {
        const valores = this.form.value

        if (valores.numero) {
            estabelecimento.numero = valores.numero
        }

        estabelecimento.codigoAcesso = valores.codigoAcesso
        estabelecimento.token = valores.token
        estabelecimento.dataInicial = valores.dataInicial
        estabelecimento.utilizaApi = valores.utilizaApi
        estabelecimento.agente.usuario = valores.usuario

        if (!this.senhaObrigatoria) {
            estabelecimento.agente.senha = ''
        } else if (!this.isEdicao || this.alterarSenha) {
            estabelecimento.agente.senha = valores.senha
        }

        if (!this.isEdicao) {
            estabelecimento.empresa.empresa = valores.empresa
            estabelecimento.agente.operadoraDeMaquina = valores.operadora
        }

        if (DadosOperadoras.utilizaToken(estabelecimento.agente.operadoraDeMaquina)) {
            if (!valores.token) {
                estabelecimento.situacao = Situacao.Inativo
            } else {
                estabelecimento.situacao = Situacao.Ativo
            }
        }
    }

    primeiroDiaMes() {
        let diaPrimeiro = moment().startOf('month')._date
        return diaPrimeiro
    }

    limiteData($event) {
        if (!$event) return

        var agora = new Date()
        var ontem = new Date(agora.getFullYear(), agora.getMonth(), agora.getDate() - 1)
        this.limite = ontem

        for (let prop in $event) {
            if (prop === '_limiteParaSincronizaremMeses') {
                this.limiteParaSincronizaremMeses = $event[prop]
            }
            if (prop === '_codename') {
                this.nome = $event[prop]
            }
        }
        return
    }

    get datasDesabilitadas() {
        var agora = new Date()
        this.dataMaximaPeriodoInicial = new Date(
            agora.getFullYear(),
            agora.getMonth(),
            agora.getDate() - this.limiteParaSincronizaremMeses * 30
        )

        if (this.estabelecimento.dataInicial < this.dataMaximaPeriodoInicial) {
            return true
        }
        return false
    }

    private atualizarInputNumero(operadora: OperadoraDeMaquina) {
        const descricao = DadosOperadoras.numeroEstabelecimentoDescricao(operadora)
        const explicacao = DadosOperadoras.numeroEstabelecimentExplicacao(operadora)

        this.numeroLabel = '*' + this.maiusculizarPrimeiraLetra(descricao)
        this.numeroPlaceholder = `${
            explicacao.length > 28
                ? this.maiusculizarPrimeiraLetra(explicacao)
                : 'Informe o ' + explicacao
        }`
        this.numeroMaxlength = DadosOperadoras.numeroEstabelecimentoMaxlength(operadora)
    }

    private maiusculizarPrimeiraLetra(texto) {
        if (typeof texto !== 'string') return ''
        return texto.charAt(0).toUpperCase() + texto.slice(1)
    }

    private atualizarInputUsuario(operadora: OperadoraDeMaquina) {
        const descricao = DadosOperadoras.usuarioDescricao(operadora)

        this.usuarioLabel = `*${descricao}`
        this.usuarioPlaceholder = `Informe o ${descricao.toLowerCase()}`
        this.usuarioDeveSerEmail = DadosOperadoras.usuarioEmail(operadora)
        this.usuarioMaxlength = DadosOperadoras.usuarioMaxlength(operadora)
        this.usuarioNumerico = DadosOperadoras.usuarioNumerico(operadora)
        this.usuarioPattern = DadosOperadoras.usuarioNumerico(operadora)
            ? NUMBER_PATTERN
            : undefined
    }

    private atualizarInputSenha(operadora: OperadoraDeMaquina) {
        this.senhaMaxlength = DadosOperadoras.senhaMaxlength(operadora)
        this.senhaNumerica = DadosOperadoras.senhaNumerica(operadora)
        this.senhaPattern = DadosOperadoras.senhaNumerica(operadora)
            ? NUMBER_PATTERN
            : undefined
    }

    private obterMicrocopiaOperadora(operadora: OperadoraDeMaquina) {
        const codename = operadora && operadora.codename.toLowerCase()

        switch (codename) {
            case 'sodexo':
                // tslint:disable-next-line:max-line-length
                return 'Os produtos homologados desta operadora são: Alimentação Pass, Cheque Refeição Pass, Combustível Pass, Gift Pass, Refeição Pass e Premium Pass.'
        }
        return undefined
    }

    private atualizarInputCodigoAcesso(operadora: OperadoraDeMaquina) {
        this.codigoAcessoMaxlength = DadosOperadoras.codigoAcessoMaxlength(operadora)
    }

    precisaToken($event) {
        if (!$event) return
        this.operadoraToken = $event.codename
    }

    hasModalToken() {
        switch (this.operadoraToken) {
            case 'PagSeguro':
                return true
        }
        return false
    }

    exibirEsconderSenha(id) {
        let input = document.querySelector('#' + id)
        let campo =
            id === 'senha' ? this.form.value.senha : this.form.value.confirmacaoSenha

        if (campo && input.getAttribute('type') === 'password') {
            input.setAttribute('type', 'text')
        } else {
            input.setAttribute('type', 'password')
        }
    }

    formatarNumeroEstabelecimento(cnpj) {
        while (cnpj && cnpj.toString().length >= 12 && cnpj.toString().length < 14) {
            cnpj = '0'.concat(cnpj)
        }
        return cnpj
    }

    confirmacaoEmail(operadoras) {
        if (!operadoras) return
        this.operadoraConfirmaEmail = operadoras._codename
    }

    alertConfirmacaoEmail() {
        switch (this.operadoraConfirmaEmail) {
            case 'Stone':
                return true
        }
        return false
    }

    isSenhaObrigatoriaByOperadora(nomeOperadora) {
        switch (nomeOperadora) {
            case 'Stone':
            case 'SumUp':
                return false
        }

        return true
    }

    isNecessarioConfirmar() {
        let nomeOperadora = this.estabelecimento.agente.operadoraDeMaquina.nome
        switch (nomeOperadora) {
            case 'Stone':
                return true
            case 'Redecard':
                return true
        }
        return false
    }

    emailConfirmado() {
        if (this.estabelecimento.utilizaApi == true) {
            return true
        }

        return false
    }

    naoPermitirEspacos(event) {
        return event.charCode !== 32
    }

    getModalConfirmacaoContent() {
        let nomeOperadora = this.estabelecimento.agente.operadoraDeMaquina.nome
        switch (nomeOperadora) {
            case 'Stone':
                return `
                    <div class="text-justify">
                        Para que a Stone disponibilize os dados de cartão de crédito para o Collect é necessário que o estabelecimento autorize junto a Stone esse tipo de coleta,
                        sendo assim, a Stone irá enviar um email, para o email que consta no cadastro junto a operadora, com um termo de permissão.
                        É necessário autorizar através deste email a coleta para que o Collect possa obter os dados
                    </div>
                    <br/>
                    <div>
                        <strong>Atenção:</strong> A Coleta de dados só irá ocorrer após essa autorização junto a Stone.
                        <a target="_blank" rel="noopener noreferrer" href="https://ajuda.alterdata.com.br/cbc/collect-status-site-exigindo-acao-do-usuario-ao-buscar-dados-da-operadora-stone">Saiba Mais</a>
                    </div>
                    <br/>
                `
            case 'Redecard':
                return `
                    <div class="text-justify">
                        Para que a Redecard disponibilize os dados de cartão de crédito para o Collect é necessário que o estabelecimento autorize junto a Redecard esse tipo de coleta,
                        sendo assim, é necessário que o usuário dê autorização de conciliação para a Alterdata Software dentro do site da Redecard.
                    </div>
                    <br/>
                    <div>
                        <strong>Atenção:</strong> A Coleta de dados só irá ocorrer após essa autorização junto a Redecard.
                        <a target="_blank" rel="noopener noreferrer" href="https://ajuda.alterdata.com.br/cbc/collect-mudancas-na-operadora-rede-que-impactam-no-collect">Saiba Mais</a>
                    </div>
                    <br/>
                `
        }
    }
}

const ERROR_MESSAGES = {
    required: 'Campo obrigatório',
    pattern: 'Apenas números.',
    equalsTo: 'Confirmação incorreta.',
    email: 'Insira um endereço de e-mail válido.',
}
const NUMBER_PATTERN = '^[0-9]*$'



// WEBPACK FOOTER //
// ./src/app/estabelecimentos/estabelecimento-modal/estabelecimento-modal.component.ts